import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyArrowLeftIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./ArrowLeftIcon-bf211430.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyArrowLeftIcon as P };
